import React from 'react'
import ReactDOM from 'react-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import { register } from './serviceWorker' // Importando a função register corretamente

import App from './App'

const DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE || 'pt-BR'

// Clear stale error counter that was forcing logout loops
if (typeof window !== 'undefined') {
  window.localStorage.removeItem('genericErrorCount')
}

if (typeof document !== 'undefined') {
  const { documentElement, body } = document
  if (documentElement) {
    documentElement.setAttribute('lang', DEFAULT_LANGUAGE)
    documentElement.setAttribute('translate', 'no')
    documentElement.classList.add('notranslate')
  }

  if (body) {
    body.setAttribute('lang', DEFAULT_LANGUAGE)
    body.setAttribute('translate', 'no')
    body.classList.add('notranslate')
  }
}

ReactDOM.render(
  <CssBaseline>
    <App />
  </CssBaseline>,
  document.getElementById('root'),
  () => {
    window.finishProgress()
  }
)

// Registrar o service worker
register()
